<rt-assistant-list-card [linkTarget]="linkTarget()" [label]="data().title" widgetType="talent-pool">
  <div class="layout">
    <rt-icon-container
      class="leading"
      shape="squircle"
      containerSize="large"
      size="small"
      name="nav-talent-pools-outline"
      color="colorIconDefault"
      background="colorBgNeutralDefault"
    />
    <div class="text">
      <span class="title">{{ data().title }}</span>
      @if (!!data().candidatesCount) {
        <span class="meta">{{
          'tlc.tellent_assistant.list_item.candidates_count'
            | translate: { count: data().candidatesCount }
        }}</span>
      }
    </div>
  </div>
</rt-assistant-list-card>
